import React, { useEffect, useState ,createContext} from 'react'
import Select,{InputProps, OnChangeValue } from 'react-select'
import s from './Header.module.scss'
import { GlobalSvgSelector } from '../../../Assets/icons/global/GlobalSvgSelector'
import { useTheme } from '../../../hooks/useTheme'
import { Theme } from '../../../context/ThemeContext'
import { Home } from '../../Home/Home'
import { ThisDay } from '../../../Components/ThisDay/ThisDay'


type Props = {}

export const CityContext = createContext("Липецк")

export const Header = (props: Props) => {
  const theme = useTheme();
 
  const options = [
    { value: 'Липецк', label: 'Липецк' },  
  ]

  const [currentCity, setCurrentCity] = useState("");

const colorStyles = {
    control: (styles: any) =>({
        ...styles,
        backgroundColor: theme.theme ===Theme.DARK ? '#4F4F4F' : 'rgba(71, 147, 255, 0.2)',
        width: '194px',
        height: '37px',
        border: 'none',
        borderRadius: '10px',
        zIndex: 100
    }),
    singleValue: (styles: any) =>({
        ...styles,
        color: theme.theme ===Theme.DARK  ? '#fff' : '#000',
    })
}

  function changeTheme(){
    theme.changeTheme( theme.theme === Theme.LIGHT ? Theme.DARK : Theme.LIGHT)

    }


const getValue = () =>{
  console.log(currentCity);
}
  


  return (
    <header className={s.header}>
        <div className={s.wrapper} >
            <div className={s.logo}> <GlobalSvgSelector id="header-logo" /> </div>
            <div className={s.title}>React weather</div>
        </div>
        <div className={s.wrapper} >
            <div className={s.change__them} onClick={changeTheme}>
            <GlobalSvgSelector id="change-theme" /> 
            </div>
            <CityContext.Provider value={currentCity} >
            <Select onChange={(choice : any ) => setCurrentCity(choice.value)} value={getValue()} styles={colorStyles} />
            </CityContext.Provider>

        </div>
    </header>
  )
}
